import { FC } from 'react';
import { DataCellProps } from '../types';

/** Active / Inactive; blank while the status is unknown (GLX-2014). */
export const TeamMemberSignInStatusCell: FC<DataCellProps> = ({ member }) => {
  if (member.login_enabled == null) return <div />;

  return <div>{member.login_enabled ? 'Active' : 'Inactive'}</div>;
};
